import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const datto = defineConnector({
  identifier: "datto",
  name: "Datto",
  tagLine: "Backup, disaster recovery, and MSP tools",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.datto\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: app.secret.secretKey,
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Datto](https://www.datto.com/) partner portal, go to **Integrations → API** and generate your API keys.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.datto.com/v1/bcdr/device",
  },
});
